import { ComponentType } from 'react';

import { createColumnDependencies } from './columns';
import DateRangePickerAccessed, {
  dependencies as dateRangePickerAccessedDependencies,
} from './components/FilterPanel/filters/DateRangePickerAccessed';
import DateRangePickerCreated, {
  dependencies as dateRangePickerCreatedDependencies,
} from './components/FilterPanel/filters/DateRangePickerCreated';
import DateRangePickerModified, {
  dependencies as dateRangePickerModifiedDependencies,
} from './components/FilterPanel/filters/DateRangePickerModified';
import DateRangePickerStartTime, {
  dependencies as dateRangePickerStartTimeDependencies,
} from './components/FilterPanel/filters/DateRangePickerStartTime';
import NameContains, {
  dependencies as nameContainsDependencies,
} from './components/FilterPanel/filters/NameContains';
import TagsMultiSelect, {
  dependencies as tagsMultiDependencies,
} from './components/FilterPanel/filters/TagsMultiSelect';
import TypeMultiSelect, {
  dependencies as typeMultiDependencies,
} from './components/FilterPanel/filters/TypeMultiSelect';

export interface FilterWithDependencies {
  key: string;
  component: ComponentType;
  dependencies: ReturnType<typeof createColumnDependencies>;
}

const filtersManifest: Array<FilterWithDependencies> = [
  {
    key: 'nameContains',
    component: NameContains,
    dependencies: nameContainsDependencies,
  },
  {
    key: 'typeMultiSelect',
    component: TypeMultiSelect,
    dependencies: typeMultiDependencies,
  },
  {
    key: 'tagsMultiSelect',
    component: TagsMultiSelect,
    dependencies: tagsMultiDependencies,
  },

  {
    key: 'dateRangePickerModified',
    component: DateRangePickerModified,
    dependencies: dateRangePickerModifiedDependencies,
  },
  {
    key: 'dateRangePickerAccessed',
    component: DateRangePickerAccessed,
    dependencies: dateRangePickerAccessedDependencies,
  },
  {
    key: 'dateRangePickerCreated',
    component: DateRangePickerCreated,
    dependencies: dateRangePickerCreatedDependencies,
  },
  {
    key: 'dateRangePickerStartTime',
    component: DateRangePickerStartTime,
    dependencies: dateRangePickerStartTimeDependencies,
  },
];

export default filtersManifest;
